import * as Sentry from "@sentry/react";
import axios from "axios";
import setAuthToken from "../../utils/setAuthToken";
import jwt from "jsonwebtoken";
import { isEmpty } from "lodash";
import { fetchSociety } from "./userAction";
import { clearAllCachesAndReload, clearIframesCache } from "../../utils/generalFuncs";
import { IframeV1 } from "../../components/Admin/IFrame/Iframe";
import { clearSessionSwitchFlag } from "../../components/common/sessionSwitchUtils";

export function registerEmployee(data) {
	return async function(dispatch) {
		try {
			dispatch({ type: "EMPLOYEE_START", payload: "" });
			const res = await axios.post("/auth/register/employee", data);
			console.log({ res });
			// const token = res.data.token

			if (res.data && !res.data.error) {
				dispatch({ type: "EMPLOYEE_FULFILLED", payload: "" });
				dispatch(logEmployee(data));
				return "ok"
			} else if (!res.data) {
				dispatch({ type: "EMPLOYEE_ERROR", payload: "Pas de Réponse" });
			} else {
				dispatch({ type: "EMPLOYEE_ERROR", payload: res.data.error.message });
			}
			return res;
		} catch (err) {
			console.log("[ERROR] register ", err);
			// dispatch({ type: "EMPLOYEE_ERROR", payload: err });
			return err;
		}
	};
}
export function logEmployee(data) {
	return async function(dispatch) {
		try {
			// dispatch({ type: "LOG_USER_START", payload: "" });
			const res = await axios.post("/auth/login/employee", data);
			console.log('[INFO], authAction, logEmployee,  info',{ res });

			const token = res.data.token; // PUBLIC TOKEN created with userID, email, private_token ...

			if (token) {
				localStorage.setItem("jwtToken_compta", token);
				setAuthToken(token, res.data.employee.employee_id, "EMPLOYEE"); // set token in axios header requests

				let currentUser = Object.assign({}, jwt.decode(token), res.data.user);
				delete currentUser.API_token; // GENERATED BY API ON LOGIN
				currentUser.is_employee = true
				res.data.employee.is_employee = true

				console.log("====================================");
				console.log({ currentUser });
				console.log("====================================");

				dispatch({ type: "SET_CURRENT_USER", payload: currentUser });
				clearSessionSwitchFlag();
				Sentry.setUser({
					id: String(currentUser.id || currentUser.user_id || currentUser.employee_id),
					email: currentUser.email || currentUser.user_email || undefined,
				});
				dispatch({ type: "GET_USER_INFO", payload: res.data.employee });				
				dispatch(fetchSociety());				
				return "ok";
			}			
			console.log('[ERROR] authAction logEmployee: ',res.data.error);
			return res;
		} catch (err) {
			console.log("[ERROR] logEmployee action ", err);
			return err;
		}
	};
}
export function logUser(data) {
	return async function(dispatch) {
		try {
			// dispatch({ type: "LOG_USER_START", payload: "" });
			const res = await axios.post("/auth/login", data);
			console.log('[INFO],authAction,logUser,  info',{ res });

			const token = res.data.token; // PUBLIC TOKEN created with userID, email, private_token ...

			if (token) {
				localStorage.setItem("jwtToken_compta", token);
				setAuthToken(token, res.data.user.user_id); // set token in axios header requests

				let currentUser = Object.assign({}, jwt.decode(token), res.data.user);
				delete currentUser.API_token; // GENERATED BY API ON LOGIN

				console.log("====================================");
				console.log({ currentUser });
				console.log("====================================");

				dispatch({ type: "SET_CURRENT_USER", payload: currentUser });
				clearSessionSwitchFlag();
				Sentry.setUser({
					id: String(currentUser.id || currentUser.user_id),
					email: currentUser.email || currentUser.user_email || undefined,
				});
				dispatch({ type: "GET_USER_INFO", payload: res.data.user });				
				if (!isEmpty(res.data.user.user_employee_id)){
					dispatch(getUserEmployeeInfo(res.data.user.user_employee_id))
				}
				dispatch(fetchSociety());
				return "ok";
			}			
			console.log('[ERROR] authAction logUser: ',res.data.error);
			return res;
		} catch (err) {
			console.log("[ERROR] login action ", err);
			return err;
		}
	};
}

export function getUserInfo() {
	return async function(dispatch) {
		try {

			dispatch({ type: "GET_USER_INFO_START", payload: "" });
			let res = await axios.get("/users/userInfo");
			console.log({ res });

			if (res.data.error) {
				console.log("ERROR", res.data.error);
				dispatch(checkError(res.data.error))
				
			} else {
				dispatch({ type: "GET_USER_INFO", payload: res.data });
				dispatch({ type: "GET_USER_INFO_FULFILLED", payload: "" })
				dispatch(fetchSociety());
			}
		} catch (error) {
			console.log("ERROR", error);
			dispatch({ type: "GET_USER_INFO_ERROR", payload: error });

		}
	};
}
export function getEmployeeInfo() {
	return async function(dispatch) {
		try {

			dispatch({ type: "GET_EMPLOYEE_INFO_START", payload: "" });
			let res = await axios.get("/users/employeeInfo");
			console.log({ res });

			if (res.data.error) {
				console.log("ERROR", res.data.error);
				dispatch(checkError(res.data.error))
				
			} else {
				dispatch({ type: "GET_EMPLOYEE_INFO", payload: res.data });
				dispatch({ type: "GET_EMPLOYEE_INFO_FULFILLED", payload: "" })
				dispatch(fetchSociety());
			}
		} catch (error) {
			console.log("ERROR", error);
			dispatch({ type: "GET_EMPLOYEE_INFO_ERROR", payload: error });

		}
	};
}
export function getUserEmployeeInfo(employee_id) {
	return async function(dispatch) {
		try {

			dispatch({ type: "GET_EMPLOYEE_INFO_START", payload: "" });
			let res = await axios.post("/users/employee/single", {data: employee_id});
			console.log({ res });

			if (res.data.error) {
				console.log("ERROR", res.data.error);
				dispatch(checkError(res.data.error))
				
			} else {
				dispatch({ type: "GET_EMPLOYEE_INFO", payload: res.data });
				dispatch({ type: "GET_EMPLOYEE_INFO_FULFILLED", payload: "" })
				dispatch(fetchSociety());
			}
		} catch (error) {
			console.log("ERROR", error);
			dispatch({ type: "GET_EMPLOYEE_INFO_ERROR", payload: error });

		}
	};
}


export function setCurrentUser(user) {
	return async function(dispatch) {
		dispatch({
			type: "SET_CURRENT_USER",
			payload: user
		})
		clearSessionSwitchFlag();
		if (user && (user.id || user.user_id)) {
			Sentry.setUser({
				id: String(user.id || user.user_id),
				email: user.email || user.user_email || undefined,
			});
		}
		if (user.role !== -1) {
			dispatch(getUserInfo())
		}

		if (!isEmpty(user.user_employee_id)) {
			dispatch(getUserEmployeeInfo(user.user_employee_id))
		}
	}
}
export function setCurrentEmployee(user) {
	return async function(dispatch) {
		dispatch({
			type: "SET_CURRENT_USER",
			payload: user
		})
		clearSessionSwitchFlag();
		if (user && (user.id || user.user_id || user.employee_id)) {
			Sentry.setUser({
				id: String(user.id || user.user_id || user.employee_id),
				email: user.email || user.user_email || undefined,
			});
		}
		dispatch(getEmployeeInfo())
	}
}

export function logout() {
	return dispatch => {
		localStorage.removeItem("jwtToken_compta");
		setAuthToken(false);
		clearSessionSwitchFlag();
		Sentry.setUser(null);
		// dispatch(setCurrentUser({}));
		dispatch({
			type: "USER_LOGOUT",
			payload: {}
		})

		console.log("logout, nettoyage des iframes et reload avec cache clear");
		
		// Nettoyer toutes les iframes avant le rechargement (méthode 1)
		try {
			IframeV1.clearAllIframes();
			console.log("Toutes les iframes ont été nettoyées via IframeV1");
		} catch (error) {
			console.log("Erreur lors du nettoyage des iframes via IframeV1:", error);
		}

		// Nettoyer également via la fonction utilitaire (méthode 2)
		try {
			clearIframesCache();
			console.log("Caches des iframes nettoyés via clearIframesCache");
		} catch (error) {
			console.log("Erreur lors du nettoyage des caches iframe:", error);
		}


	};
}
export function checkError(error) {
	return dispatch => {
		console.log('====================================');
		console.log({error});
		console.log('====================================');
		if( !error ){
			return
		}
		switch(error.statusCode){
			case 403: 
				dispatch(logout())
				break
			default:
				return

		}
	}
}
export function checkErrorData(res, type, dispatch) {
	let noError = false
	
	
	if( !res.data ){
		dispatch({
			type,
			payload: "pas de réponse"
		})
	} else if (res.data.error){

		if (res.data.error.statusCode === 403){
			dispatch(logout())
		} else {
			dispatch({
				type,
				payload: res.data.error.error
			})
		}
		
	} else {
		noError = true
	}
	return noError
	
}
export function checkErrorDataNull(res, type, dispatch) {
	let noError = false
	
	if( res.data && res.data.error){

		if (res.data.error.statusCode === 403){
			dispatch(logout())
		} else {
			dispatch({
				type,
				payload: res.data.error.error
			})
		}
		
	} else {
		noError = true
	}
	return noError
	
}


export function resetPassword(email) {
	return async function(dispatch) {
		try {
			let res = await axios.post("/auth/reset/password",{email});
			console.log({ res });

			// if (res.data.error) {
			// 	console.log("ERROR", res.data.error);
			// 	// dispatch(checkError(res.data.error))
				
			// } else {
			// 	dispatch({ type: "GET_USER_INFO", payload: res.data.user_info });
			// 	// dispatch({ type: "USER_INFO_FULFILLED", payload: "" })
			// }
		} catch (error) {
			console.log("ERROR", error);
		}
	};
}
export function resetPasswordUpdate(data) {
	return async function(dispatch) {
		try {
			let res = await axios.post("/auth/reset/password/update",{data});
			console.log({ res });

			// if (res.data.error) {
			// 	console.log("ERROR", res.data.error);
			// 	// dispatch(checkError(res.data.error))
				
			// } else {
			// 	dispatch({ type: "GET_USER_INFO", payload: res.data.user_info });
			// 	// dispatch({ type: "USER_INFO_FULFILLED", payload: "" })
			// }
		} catch (error) {
			console.log("ERROR", error);
		}
	};
}

const isHtmlResponse = data => typeof data === "string" && data.trim().startsWith("<");

export function getOrganizationName() {
	return async function(dispatch) {
		try {
			dispatch({ type: "GET_ORGANIZATION_NAME_START", payload: "" });
			let res = await axios.get("/organization-accounts/current-user/organization-name");
			console.log('[INFO] getOrganizationName response:', { res });

			if (isHtmlResponse(res.data)) {
				const errorMessage = "Invalid organization response";
				console.warn("[WARN] getOrganizationName received HTML instead of JSON");
				dispatch(checkError(errorMessage));
				dispatch({ type: "GET_ORGANIZATION_NAME_ERROR", payload: errorMessage });
				return;
			}

			if (res.data.error) {
				console.log("ERROR", res.data.error);
				dispatch(checkError(res.data.error));
				dispatch({ type: "GET_ORGANIZATION_NAME_ERROR", payload: res.data.error });
			} else {
				const organizationName = res.data.organization_name || res.data;
				dispatch({ type: "GET_ORGANIZATION_NAME", payload: organizationName });
				dispatch({ type: "GET_ORGANIZATION_NAME_FULFILLED", payload: "" });
			}
		} catch (error) {
			console.log("ERROR getOrganizationName", error);
			dispatch({ type: "GET_ORGANIZATION_NAME_ERROR", payload: error });
		}
	};
}

